module.exports = __webpack_public_path__ + "img/permisson-comparison5.d4494bfc.jpg";